"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_export_templates_service_client_js_1 = require("@synisys/idm-export-templates-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var operators_1 = require("rxjs/operators");
var BehaviorSubject_1 = require("rxjs/BehaviorSubject");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var HeaderSettingsComponent = /** @class */ (function () {
    function HeaderSettingsComponent(communicationService, exportTemplatesService, currentLanguageProvider) {
        this.communicationService = communicationService;
        this.exportTemplatesService = exportTemplatesService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.extensions = ['PDF', 'DOCX', 'XLS'];
        this._selectedTemplates = new BehaviorSubject_1.BehaviorSubject([]);
    }
    Object.defineProperty(HeaderSettingsComponent.prototype, "category", {
        get: function () {
            return this._category;
        },
        set: function (value) {
            this._category = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderSettingsComponent.prototype, "filteredSelectedTemplates", {
        get: function () {
            return this._filteredSelectedTemplates;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderSettingsComponent.prototype, "selectedTemplates", {
        get: function () {
            return this._selectedTemplates;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderSettingsComponent.prototype, "exportTemplatesData", {
        get: function () {
            return this._exportTemplatesData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderSettingsComponent.prototype, "state", {
        set: function (value) {
            if (value['exportTemplates']) {
                this._selectedTemplates.next(value['exportTemplates']);
            }
        },
        enumerable: true,
        configurable: true
    });
    HeaderSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._exportTemplatesData = this.currentLanguageProvider
            .getCurrentLanguage()
            .pipe(operators_1.switchMap(function (currentLanguage) {
            return _this.exportTemplatesService.loadTemplatesDataByCategoryName(_this.category, currentLanguage.getId());
        }), operators_1.map(function (templates) {
            var viewExportTemplates = templates.map(function (template) { return ({
                id: template.id,
                name: template.name,
                extension: 'PDF',
            }); });
            return {
                items: viewExportTemplates,
                name: '',
            };
        }));
        this.subscription = combineLatest_1.combineLatest(this.selectedTemplates, this.exportTemplatesData).subscribe(function (_a) {
            var selectedTemplates = _a[0], exportTemplatesData = _a[1];
            _this._filteredSelectedTemplates = selectedTemplates.filter(function (item) {
                return exportTemplatesData.items.some(function (item1) { return item1.id === item.id; });
            });
            _this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
                state: {
                    exportTemplates: _this.filteredSelectedTemplates,
                },
            }));
        }, console.log);
    };
    HeaderSettingsComponent.prototype.onSelectedTemplatesChange = function (selectedItems) {
        this._selectedTemplates.next(selectedItems.map(function (item) { return ({
            id: item.id.toString(),
            name: item.name,
            extension: item.comboItem,
        }); }));
    };
    HeaderSettingsComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], HeaderSettingsComponent.prototype, "category", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], HeaderSettingsComponent.prototype, "state", null);
    HeaderSettingsComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-header-settings',
            template: require('./header-settings.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n        <sis-header-settings [state]=\"%{state}\" [category]=\"%{category}\">\n        </sis-header-settings>\n    ",
        }),
        __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService,
            idm_export_templates_service_client_js_1.ExportTemplatesService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], HeaderSettingsComponent);
    return HeaderSettingsComponent;
}());
exports.HeaderSettingsComponent = HeaderSettingsComponent;
//# sourceMappingURL=header-settings.component.js.map